<template>
    <div :class="{'col-md-6': isString, 'col-md-12': isObject}">
        <div class='list-item' v-if="isString" @click="insert(slug, name, false)">
                <div class="action pull-left margin-right-15">
                    <button class="btn btn-xs btn-outline dark" style="border: none">
                        <i class="glyphicon glyphicon-plus"></i>
                    </button>
                </div>
                <div class="list-item-info">
                    <div class="item-title" v-text="name"></div>
                    <!--<div class="item-slug" v-text="slug"></div>-->
                </div>
        </div>
        <div v-if="isObject" class="row list-item array-list-item" :class="{'disabled': ! canBeInserted}">
            <div class="col-md-12">
                <h5 class="text-center">
                    <i class='glyphicon glyphicon-list-alt'></i> <strong>{{ slug | titleCase }}</strong>
                </h5>
            </div>

            <template v-for="(value, index) in name">
                <!-- frunza-string: inline, pastreaza guard-ul colectiei (this.canBeInserted) -->
                <div v-if="isLeaf(value)" :key="`leaf-${index}`" class="col-md-6 margin-bottom-10" @click="insert(index, value, true)">
                    <div class="action pull-left margin-right-15">
                        <button class="btn btn-xs btn-outline dark" style="border: none">
                            <i class="glyphicon glyphicon-plus"></i>
                        </button>
                    </div>
                    <div class="list-item-info">
                        <div class="item-title" v-text="value"></div>
                    </div>
                </div>
                <!-- sub-colectie (obiect): recursie, acumuleaza path-ul pentru breadcrumb -->
                <variable-list-item
                        v-else
                        :key="`node-${index}`"
                        :name="value"
                        :slug="index"
                        :path="childPath"
                        :collection-path="childCollectionPath"
                        @insert="$emit('insert', $event)"
                ></variable-list-item>
            </template>

            <small v-if="! canBeInserted" class="col-md-12"><br><i class='glyphicon glyphicon-exclamation-sign'></i> In order to use this section you must have the cursor located in a table or a list.</small>
        </div>

    </div>

</template>

<script>
    export default {
        name: "variable-list-item",

        props: {
            name: {
                required: true
            },
            slug: {
                required: true
            },
            // APS-2587: cheile grupurilor parinte pentru breadcrumb-ul NUMELUI (include sectiunea top-level)
            path: {
                type: Array,
                default: () => []
            },
            // APS-2587: cheile colectiilor parinte pentru TOKEN (exclude sectiunea top-level)
            collectionPath: {
                type: Array,
                default: () => []
            }
        },

        data() {
            return {
                canBeInserted: true
            }
        },

        mounted() {
            eventBus.$on('checkEligibleArrayItems', () => {
                this.canBeInserted = true;
                let hasCollectionFunctionClass = $(tinyMCE.activeEditor.selection.getNode()).parent().hasClass('blade-collection-function');

                if (this.isObject && _.indexOf(['td','li','ol'], _.lowerCase(tinyMCE.activeEditor.selection.getNode().nodeName)) < 0 && !hasCollectionFunctionClass) {
                    this.canBeInserted = false;
                }
            })
        },

        computed: {
            isString() {
                return typeof this.name === 'string'
            },
            isObject() {
                return typeof this.name === 'object'
            },
            // path-ul transmis copiilor (obiecte) la recursie
            childPath() {
                return this.path.concat(this.slug)
            },
            childCollectionPath() {
                return this.collectionPath.concat(this.slug)
            }
        },

        methods: {
            isLeaf(value) {
                return typeof value === 'string'
            },

            titleCase(value) {
                return _.startCase(_.toLower(value))
            },

            /**
             * APS-2587: construieste breadcrumb-ul complet (grup-intai) in textul
             * span-ului blade-variable, la orice adancime. Cheia variabilei
             * (token-ul de substitutie) ramane neschimbata fata de comportamentul
             * existent: sectiunea NU intra in token, doar lantul de colectii.
             *
             * @param leafKey           cheia variabilei frunza
             * @param leafLabel         eticheta variabilei (text afisat)
             * @param isCollectionChild true daca frunza e copilul acestei colectii (isObject)
             */
            insert(leafKey, leafLabel, isCollectionChild = false) {
                let collectionKeys = this.collectionPath.slice()
                let nameKeys = this.path.slice()
                if (isCollectionChild) {
                    collectionKeys.push(this.slug)
                    nameKeys.push(this.slug)
                }

                let variable = collectionKeys.length ? `${collectionKeys.join('|')}|${leafKey}` : `${leafKey}`
                let phpVariable = `$${variable}`
                let bladeVariable = `{{${phpVariable}}}`
                let name = nameKeys.map((key) => this.titleCase(key)).concat(leafLabel).join(' - ')

                let html = `<span   class="blade-variable mceNonEditable"
                                    data-blade-variable="${bladeVariable}"
                                    data-php-variable="${phpVariable}"
                                    data-variable="${variable}"
                            >${name}</span>`

                if (this.canBeInserted) {
                    this.$emit('insert', {
                        variable: html
                    })
                }
            }
        }
    }
</script>
